import React, { useEffect } from "react";
import Layout from "./common/Layout";

const ContactUs = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
        <section className="py-5 bg-light-primary">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <h1 className="display-4 fw-bolder text-primary-s mb-4 wow animated fadeInDown">Contact Us</h1>
                <span className="sep mt-4 mx-auto d-block wow animated fadeInUp"></span>
                <p className="lead text-muted mt-4 wow animated fadeInUp">We're here to help you with any questions or concerns</p>
              </div>
            </div>
          </div>
        </section>


        <section className="py-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="contact-content">
                  
                  {/* Contact Information Section */}
                  <div className="row mb-5">
                    <div className="col-lg-8">
                      <div className="contact-info-section">
                        <h3 className="h4 fw-bold text-primary-s mb-4 d-flex align-items-center">
                          <span className="box-icon me-3">
                            <i className="fa fa-envelope"></i>
                          </span>
                          Get in Touch
                        </h3>
                        <p className="lead line-h-170 mb-4">
                          For support or questions about our TLSAE course, we're here to help! Our dedicated support team is available to assist you with any concerns or inquiries you may have.
                        </p>
                        
                        <div className="contact-details">
                          <div className="contact-item mb-4">
                            <div className="d-flex align-items-center">
                              <div className="contact-icon me-3">
                                <i className="fa fa-envelope "></i>
                              </div>
                              <div>
                                <h5 className="mb-1">Email Support</h5>
                                <p className="mb-0 text-muted">For general inquiries and course support</p>
                                <a href="mailto:support@floridadrivingpermit.com" className="text-primary-s fw-bold">
                                  support@floridadrivingpermit.com
                                </a>
                              </div>
                            </div>
                          </div>

                          <div className="contact-item mb-4">
                            <div className="d-flex align-items-center">
                              <div className="contact-icon me-3">
                                <i className="fa fa-phone "></i>
                              </div>
                              <div>
                                <h5 className="mb-1">Phone Support</h5>
                                <p className="mb-0 text-muted">Available during business hours</p>
                                <a href="tel:503-710-1720" className="text-primary-s fw-bold">
                                  503-710-1720
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div className="col-lg-4">
                      <div className="contact-image-section text-center">
                        <div className="contact-image-box">
                          <i className="fa fa-headset contact-main-icon"></i>
                        </div>
                        <h4 className="text-primary-s mt-3">24/7 Course Access</h4>
                        <p className="text-muted">Your course is available anytime, anywhere</p>
                      </div>
                    </div>
                  </div>


                 

                 
                </div>
              </div>
            </div>
          </div>
        </section>
    </Layout>
  );
};

export default ContactUs;
